/*
 * File: product-toolbar-search-info.component.ts                              *
 * Project: catalog-cloud                                                      *
 * File Created: Sunday, 6th March 2022 23:00:15                               *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Friday, 2nd December 2022 14:57:34                           *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */

import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Product } from '@nousmedis/cc-types';
import { ProductService } from '../../../services/product.service';
import { ToggleButton } from 'primeng/togglebutton';
import { FilterOptions } from 'app/modules/catalog-cloud/interfaces/filter-options.interface';


@Component({
  selector: 'app-product-toolbar-search-info',
  templateUrl: './product-toolbar-search-info.component.html',
  styleUrls: ['./product-toolbar-search-info.component.scss'],
})
export class ProductToolbarSearchInfoComponent implements OnInit, AfterViewInit {
  @Input() filteredProducts: number;
  @Input() allProducts: number;
  @Input() showInsertedProducts: boolean;
  @Input() viewType: string;
  @Input() loading: boolean = true;
  @Input() productOrder: string;
  @Input() filterOptions: FilterOptions;

  orderOptions: { label: string; value: string; icon: string; }[] = [
    {
      label: 'Asc', value: 'asc',
      icon: 'fa fa-arrow-up-a-z'
    },
    {
      label: 'Desc', value: 'desc',
      icon: 'fa fa-arrow-down-a-z'

    },
  ];
  selectedOrder: string = 'asc';
  viewOptions: { label: string; value: string; icon: string; }[] = [
    { label: 'List', value: 'list', icon: 'fa fa-list' },
    { label: 'Grid', value: 'grid', icon: 'fa fa-table' },
  ];
  selectedView: string = 'list';

  showProductDetails: boolean;

  @Output() viewTypeChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() orderChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() showInsertedProductsChange: EventEmitter<boolean> =
    new EventEmitter<boolean>();


  @Output() forceReload: EventEmitter<boolean> = new EventEmitter<boolean>();



  @ViewChild('order') orderView: ToggleButton;
  @ViewChild('productView') productView: ToggleButton;


  constructor (private productService: ProductService) { }
  ngAfterViewInit(): void {
    this.loading = false;
  }

  ngOnInit(): void {
    this.selectedOrder = this.filterOptions.sort
    this.selectedView = this.filterOptions.viewType
   }

  toggleShowInsertedProducts() {
    this.showInsertedProducts = this.showInsertedProducts ? false : true;
    this.showInsertedProductsChange.emit(this.showInsertedProducts);
    this.forceReload.emit(true);
  }

  changeOrder(order: string) {
    this.selectedOrder = order;
    this.orderChange.emit(order);
    
  }

  changeViewType(view: string) {
    this.selectedView = view;
    this.viewTypeChange.emit(this.selectedView);
    // if ((this.productView) && (this.productView.checked)) this.viewTypeChange.emit(this.productView.value);
    
  }
}
